import { Box, BoxProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Logo({ sx }: BoxProps) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const logoSrc = isLight ? '/static/brand/LOGOdark.svg' : '/static/brand/LOGOlight.svg';

  return (
    <Box sx={{ minWidth: 40, minHeight: 40, width: '100%', height: '100%', ...sx }}>
      <img src={logoSrc} alt="Logo" style={{ width: '100%', height: '100%' }} />
    </Box>
  );
}
